import React from "react";
import { Typography, useTheme } from "@mui/material";

const DomainGroupHeader = ({ domain, showDomain }) => {
  const theme = useTheme();

  if (!showDomain) return null;

  return (
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 700,
        mb: 2.5,
        fontSize: "16px",
        color: theme.customColors.text.strong,
      }}
    >
      {domain}
    </Typography>
  );
};

export default DomainGroupHeader;
